import React, { Fragment, Component } from 'react';
import jsQR from "jsqr";
import { fetchData } from '../common/networkRequests';


// import './styles.css';


const CapturedImageBox = ({ imgkey, imgdata, DeleteImage, current }) => {
  let processedImages;
  try {
    processedImages = current.props.parentState.LocalVars.processedImages;
  }
  catch (err) {
    processedImages = {};
  }
  return (
    <div className="col-sm-6">
      <div style={{ position: "relative", height: 135, width: 160, borderRadius: 5 }}>
        {imgdata.saved && <div onClick={() => DeleteImage(imgkey)} style={{ position: "absolute", right: 0, top: 0, color: "black", cursor: "pointer" }}>x</div>}
        <img height={120} width={160} src={imgdata['image']} />

        {!processedImages[imgkey + ".txt"] &&
          <div style={{ height: 15, width: 160, fontSize: 11 }}>
            {imgdata.saved ? <div style={{ textAlign: "center", backgroundColor: "#133b5c", color: "white" }}>Uploaded</div> : <div style={{ textAlign: "center", backgroundColor: "gray", color: "white" }}>Uploading</div>}
          </div>
        }

        {processedImages[imgkey + ".txt"] == 'fail' &&
          <div style={{ height: 15, width: 160, fontSize: 11 }}>
            <div style={{ textAlign: "center", backgroundColor: "red", color: "white" }}>FAILED</div>
          </div>
        }

        {processedImages[imgkey + ".txt"] == 'success' &&
          <div style={{ height: 15, width: 160, fontSize: 11 }}>
            <div style={{ textAlign: "center", backgroundColor: "#188038", color: "white" }}>Processed</div>
          </div>
        }



      </div>
    </div>
  )
}


const CapturedImages = ({ images, DeleteImage, current }) => {
  return (
    <div className="row">
      {
        Object.keys(images).map((imgkey, idx) => <CapturedImageBox current={current} DeleteImage={DeleteImage} imgkey={imgkey} key={idx} imgdata={images[imgkey]} />)
      }
    </div>
  )
}


class CameraCustom extends Component {

  constructor(props) {
    super(props);
    this.state = { images: {} };
  }

  /**
       * Processes available devices and identifies one by the label
       * @memberof CameraFeed
       * @instance
       */
  processDevices(devices) {
    devices.forEach(device => {
      this.setDevice(device);
    });
  }

  /**
   * Sets the active device and starts playing the feed
   * @memberof CameraFeed
   * @instance
   */

  DeleteImage = (imgkey) => {
    console.log({ imgkey });
    let { images } = this.state;
    delete images[imgkey];
    this.setState({ images });
  }

  uploadImage = async file => {
    const current = this;
    const formData = new FormData();
    formData.append('file', file);
    const {
      options
    } = this.props.component;

    let profile = {};
    if (this.props.parentProps) {
      profile = this.props.parentProps.parentState.profile;
    }


    // convert to base64, compress and send to server.
    var reader = new FileReader();
    reader.readAsDataURL(file);
    let { images } = this.state;
    reader.onloadend = function (data) {
      var base64data = reader.result;
      let imgkey = profile.username + "_" + new Date().getTime();
      images[imgkey] = { image: base64data, saved: false };
      current.setState({ images });

      let { camtype } = options;
      if (camtype == 'kycocr') {
        let { remoteip, pageData } = current.props.parentState;
        let CBSurl = `${remoteip}/kycocr`;
        let method = 'post';
        let cbf = (ret) => {
          images[imgkey]['saved'] = true;
          current.setState({ images });
          let imgids = Object.keys(images);
          current.props.liftState({ name: 'images' }, imgids);
        }
        fetchData({ url: CBSurl, postData: { photo: base64data, filename: imgkey }, cbf, method, current });
      }
      if (current.props.processImage) {
        current.props.processImage(base64data); // Show in a caraousal below and send to server.
      }
    }
  };


  async setDevice(device) {
    const { deviceId } = device;
    const stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { deviceId } });
    try {
      this.videoPlayer.srcObject = stream;
      this.videoPlayer.play();
    } catch (e) {
      // props.liftGlobalState({ name: "errorMessages" }, {:"Camera not initialized"});
    }
  }

  /**
   * On mount, grab the users connected devices and process them
   * @memberof CameraFeed
   * @instance
   * @override
   */


  coreLoop = () => {
    const { imageStyle } = this.props.component;
    const { height, width } = imageStyle;
    const context = this.canvas.getContext('2d');
    context.drawImage(this.videoPlayer, 0, 0, width, height);
    const pixelData = context.getImageData(0, 0, width, height);
    // rawctx = this.rawCanvas.getContext('2d');

    var x = 0;
    var y = 0;
    const threshold = 70;
    // let edges = {x00:0,x01:0,x10:0,x11:00,y00:0,y01:0,y10:0,y11:00};
    let edges = [];

    var left = undefined;
    var top = undefined;
    var right = undefined;
    var bottom = undefined;
    for (var y = 0; y < pixelData.height; y++) {
      for (var x = 0; x < pixelData.width; x++) {
        // get this pixel's data
        // currently, we're looking at the blue channel only.
        // Since this is a B/W photo, all color channels are the same.
        // ideally, we would make this work for all channels for color photos.
        let index = (x + y * width) * 4;
        let pixel = pixelData.data[index + 2];

        // Get the values of the surrounding pixels
        // Color data is stored [r,g,b,a][r,g,b,a]
        // in sequence.
        left = pixelData.data[index - 4];
        right = pixelData.data[index + 2];
        top = pixelData.data[index - (width * 4)];
        bottom = pixelData.data[index + (width * 4)];

        //Compare it all.
        // (Currently, just the left pixel)
        // plotPoint(x, y);
        // console.log({right});

        if (pixel > left + threshold) {
          edges.push({ x, y });
        } else if (pixel < left - threshold) {
          edges.push({ x, y });
        } else if (pixel > right + threshold) {
          edges.push({ x, y });
        } else if (pixel < right - threshold) {
          edges.push({ x, y });
        } else if (pixel > top + threshold) {
          edges.push({ x, y });
        } else if (pixel < top - threshold) {
          edges.push({ x, y });
        } else if (pixel > bottom + threshold) {
          edges.push({ x, y });
        } else if (pixel < bottom - threshold) {
          edges.push({ x, y });
        }
      }
    }
    // Find the largest rectangle and plot it.
  }

  // plotPoint = (x, y) => {
  //   const owncontext = this.canvasown.getContext('2d');
  //   owncontext.moveTo(100, 100);
  //   owncontext.lineTo(x, y);
  //   owncontext.stroke();
  // };

  calculateEdges = () => {
    this.coreLoop();
  }

  async componentDidMount() {
    if (navigator.mediaDevices) {
      const cameras = await navigator.mediaDevices.enumerateDevices();
      if (cameras) {
        this.processDevices(cameras);
      }
    }
    // this.interval = setInterval(() => this.calculateEdges(), 10000);
  }

  /**
   * Handles taking a still image from the video feed on the camera
   * @memberof CameraFeed
   * @instance
   */
  takePhoto = () => {
    const { imageStyle } = this.props.component;
    const { height, width } = imageStyle;
    const context = this.canvas.getContext('2d');
    let b64Image = context.drawImage(this.videoPlayer, 0, 0, width, height);
    this.canvas.toBlob(this.uploadImage);
    // this.coreLoop();
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const {
      imageStyle, camtype, options, hidebtn
    } = this.props.component;


    return (
      <div className="col-sm-12 c-camera-feed row">
        <div className="col-sm-8">
          <button id="camera-button" style={{ display: hidebtn ? "none" : "block" }} onClick={this.takePhoto}>Take photo!</button>
          <div className="c-camera-feed__viewer" style={{ display: hidebtn ? "none" : "block" }} >
            <video ref={ref => (this.videoPlayer = ref)} style={{}} width={imageStyle.width} height={imageStyle.height} />
            <canvas style={{ position: 'absolute', left: 0 }} width={imageStyle.width} height={imageStyle.height} ref={ref => (this.canvasown = ref)} />
          </div>
        </div>

        <div className="col-sm-4">
          <span style={{ display: "none" }}>
            <div className="c-camera-feed__stage" >
              <canvas width={imageStyle.width} height={imageStyle.height} ref={ref => (this.canvas = ref)} />
            </div>
          </span>

          <div style={{ display: hidebtn ? "none" : "block" }} >
            <CapturedImages autosave={true} current={this} images={this.state.images} DeleteImage={this.DeleteImage} />
          </div>
        </div>

      </div>
    );
  }
}

export default CameraCustom;
